import { Box } from '@mui/system';

export function Spacing({ space = 8, width = 0 }) {
	return <Box sx={{ height: space + 'px', width: width + 'px' }}></Box>;
}
